var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "c_page-title" },
        [
          _c("div", [_vm._v("标记异常欠货日志")]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "icon-fresh",
              attrs: { size: "mini", icon: "el-icon-refresh" },
              on: {
                click: function($event) {
                  return _vm.fetchData(true)
                }
              }
            },
            [_vm._v("刷新")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c(
            "el-col",
            [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#f3f3f3",
                    height: "30px",
                    "line-height": "30px",
                    padding: "0 25px",
                    display: "flex",
                    "align-items": "center"
                  }
                },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "auto" },
                      attrs: {
                        type: "text",
                        icon: _vm.filterFold
                          ? "el-icon-arrow-down"
                          : "el-icon-arrow-up"
                      },
                      on: { click: _vm.toggleFilter }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.filterFold ? "展开筛选" : "收起筛选") +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-collapse-transition", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.filterFold,
                        expression: "!filterFold"
                      }
                    ]
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { padding: "10px 25px" } },
                      [
                        _c(
                          "el-form",
                          {
                            staticClass: "demo-form-inline",
                            attrs: { inline: true, model: _vm.form }
                          },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "筛选条件: " } },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "商品货号" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.goods_no,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "goods_no", $$v)
                                    },
                                    expression: "form.goods_no"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "商品名称" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.goods_name,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "goods_name", $$v)
                                    },
                                    expression: "form.goods_name"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.resData
                              ? _c(
                                  "el-form-item",
                                  [
                                    _c("el-input", {
                                      attrs: { placeholder: "商家" },
                                      nativeOn: {
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.search.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.form.supply_name,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "supply_name", $$v)
                                        },
                                        expression: "form.supply_name"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.resData
                              ? _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: { placeholder: "代采组" },
                                        model: {
                                          value: _vm.form.pgid,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "pgid", $$v)
                                          },
                                          expression: "form.pgid"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { label: "全部", value: "0" }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(_vm.pgOption, function(val) {
                                          return _c("el-option", {
                                            key: val.value,
                                            attrs: {
                                              label: val.label,
                                              value: val.value
                                            }
                                          })
                                        })
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: { placeholder: "代采员" },
                                    model: {
                                      value: _vm.form.pg_member_id,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "pg_member_id", $$v)
                                      },
                                      expression: "form.pg_member_id"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "全部", value: "0" }
                                    }),
                                    _vm._v(" "),
                                    _vm._l(_vm.memberOption, function(val) {
                                      return _c("el-option", {
                                        key: val.value,
                                        attrs: {
                                          label: val.label,
                                          value: val.value
                                        }
                                      })
                                    })
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.resData
                              ? _c(
                                  "el-form-item",
                                  [
                                    _c("el-input", {
                                      attrs: { placeholder: "操作人" },
                                      nativeOn: {
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.search.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.form.operator_name,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "operator_name",
                                            $$v
                                          )
                                        },
                                        expression: "form.operator_name"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.resData
                              ? _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: { placeholder: "操作原因" },
                                        model: {
                                          value: _vm.form.exception_type,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "exception_type",
                                              $$v
                                            )
                                          },
                                          expression: "form.exception_type"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { label: "全部", value: "0" }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(_vm.exceptionOption, function(
                                          item
                                        ) {
                                          return _c("el-option", {
                                            key: item.key,
                                            attrs: {
                                              label: item.label,
                                              value: item.key
                                            }
                                          })
                                        })
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "操作时间" } },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "datetimerange",
                                    "value-format": "yyyy-MM-dd HH:mm:ss",
                                    "default-time": ["00:00:00", "23:59:59"],
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期"
                                  },
                                  model: {
                                    value: _vm.form.create_time,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "create_time", $$v)
                                    },
                                    expression: "form.create_time"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.search }
                                  },
                                  [_vm._v("查询")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("el-col", { staticStyle: { border: "1px solid #ddd" } }, [
            _c(
              "div",
              {
                staticStyle: {
                  background: "#f3f3f3",
                  height: "50px",
                  "line-height": "30px",
                  padding: "0 25px",
                  display: "flex",
                  "align-items": "center"
                }
              },
              [
                _c("div", [_vm._v("列表数据：")]),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticStyle: { "margin-left": "auto" },
                    attrs: { type: "success", size: "mini" },
                    on: {
                      click: function($event) {
                        return _vm.output()
                      }
                    }
                  },
                  [_vm._v("导出")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { "margin-bottom": "0" } },
              [
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: { data: _vm.resData.data, "tooltip-effect": "dark" }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "goods_img",
                        label: "商品图片",
                        align: "center"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "div",
                                {
                                  staticStyle: { width: "100%", height: "100%" }
                                },
                                [
                                  _c("img", {
                                    staticStyle: {
                                      width: "50px",
                                      height: "50px"
                                    },
                                    attrs: { src: scope.row.main_img },
                                    on: {
                                      click: function($event) {
                                        _vm.imgs = scope.row.middle_img
                                        _vm.showImg = true
                                      }
                                    }
                                  })
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "goods_name",
                        label: "商品名称",
                        "show-overflow-tooltip": "",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "goods_no",
                        label: "商品货号",
                        "show-overflow-tooltip": "",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "co_val",
                        label: "颜色",
                        "show-overflow-tooltip": "",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "si_val",
                        label: "尺码",
                        "show-overflow-tooltip": "",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "change_num",
                        label: "数量",
                        "show-overflow-tooltip": "",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "price",
                        label: "代采价",
                        "show-overflow-tooltip": "",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "supply_name",
                        label: "商家",
                        "show-overflow-tooltip": "",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "pgname",
                        label: "代采组",
                        "show-overflow-tooltip": "",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "pg_member_name",
                        label: "代采员",
                        "show-overflow-tooltip": "",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "owe_mark_exception_exception_type",
                        label: "操作来源",
                        "show-overflow-tooltip": "",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "comments",
                        label: "备注",
                        "show-overflow-tooltip": "",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "admin_name",
                        label: "操作人",
                        "show-overflow-tooltip": "",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "create_time",
                        label: "操作时间",
                        "show-overflow-tooltip": "",
                        align: "center"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.resData
              ? _c(
                  "div",
                  { staticStyle: { "text-align": "right", padding: "25px" } },
                  [
                    _c("el-pagination", {
                      attrs: {
                        "page-sizes": [10, 50, 100],
                        "current-page": _vm.form.page,
                        background: "",
                        layout: "total, prev, pager, next, jumper,sizes",
                        total: _vm.resData.total,
                        "page-size": 10
                      },
                      on: {
                        "update:currentPage": function($event) {
                          return _vm.$set(_vm.form, "page", $event)
                        },
                        "update:current-page": function($event) {
                          return _vm.$set(_vm.form, "page", $event)
                        },
                        "size-change": _vm.handleSizeChange,
                        "current-change": _vm.handleCurrentChange
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      ),
      _vm._v(" "),
      _vm.showImg
        ? _c("preview-image", {
            attrs: { show: _vm.showImg, imgs: _vm.imgs },
            on: { closeBox: _vm.closeImg }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-26cd599f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26cd599f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/log/OweExceptionList.vue
// module id = null
// module chunks = 